<template>
  <div class="henan_home henan">
    <section class="section_first">
      <div class="first_top flex">
        <div class="first">
          <h3>热招职位</h3>
          <ul class="list" >
            <li class="box" v-for="(item,index) in home.hotJobs" :key="index" @click="goRouter('/job/jobDetail?id=',item.id)">
              <div class="left">
                <div class="name">{{ item.jobName }}</div>
                <div class="bottom" v-if="item.distype.length > 1 || item.distype.length == 0">
                  <span>残疾类别不限</span>
                </div>
                <div class="bottom" v-else>
                  <span v-for="(n,i) in item.distype" :key="i">{{ n.disType + ' ' + n.disTypeLevel }}</span>
                </div>
              </div>
              <div class="right">
                <div class="money">{{ item.jobSalary }}</div>
                <div class="address">
                  {{ item.cityid }}
                  <!--                  <span v-if="item.threeCityid">-{{item.threeCityid}}</span>-->
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="second">
          <div class="search">
            <el-input placeholder="请输入搜索的公司或职位名称" v-model="search" class="search_input">
              <el-select v-model="select" slot="prepend" placeholder="搜职位">
                <el-option label="搜职位" value="1"></el-option>
                <el-option label="搜公司" value="2"></el-option>
              </el-select>
              <el-button slot="append" @click="$linkRouter('/job?active='+search)">搜 索</el-button>
            </el-input>
            <div class="hot_job">
              <span class="name">热门职位：</span>
              <router-link to="/job?active=客服" target="_blank">客服</router-link>
              <router-link to="/job?active=销售" target="_blank">销售</router-link>
              <router-link to="/job?active=开发工程师" target="_blank">开发工程师</router-link>
              <router-link to="/job?active=理财师" target="_blank">理财师</router-link>
              <router-link to="/job?active=文员" target="_blank">文员</router-link>
              <router-link to="/job?active=售后" target="_blank">售后</router-link>
            </div>
          </div>
          <div class="swiper relative">
            <el-carousel height="272px" class="swiper_carousel" ref="swiper" indicator-position="none" @change="swiperTab">
              <el-carousel-item v-for="(item,index) in home.carousels" :key="index">
                <a :href="$getHttpUrl(item.picUrl)" target="_blank" :title="item.adName"><img :src="item.picSrc" alt=""></a>
              </el-carousel-item>
            </el-carousel>
            <ul class="position">
              <li :class="{'active':active+1 == item}" v-for="(item,index) in home.carousels" :key="index" @mouseover="swiperItem(index)">
                <img :src="item.picSrc" alt="">
              </li>
            </ul>
          </div>
        </div>
        <div class="last">
          <Login></Login>
        </div>
      </div>
      <ul class="first_bottom">
        <li>
          <a href="javascript:void(0);" @click="goRouters('/demand','',true)"><img src="~/static/henan/pic1.png" alt="" title="在线需求登记">
          </a>
        </li>
        <li>
          <a href="javascript:void(0);"><img src="~/static/henan/pic2.png" alt="" title="就业创业交流" @click="goRouters('/center/guideCreate/')"></a>
        </li>
        <li>
          <a href="https://cjrcp.webtrn.cn/zcl_zycs/zcl/general/homePage/homePage.html" target="_blank"><img src="~/static/henan/pic6.png" alt="" title="职业能力测评">
          </a>
        </li>
        <li>
          <router-link to="/heartOrder" target="_blank"><img src="~/static/henan/pic4.png" alt="" title="心理咨询预约">
          </router-link>
        </li>
        <li>
          <router-link to="/activity/live"><img src="~/static/henan/pic5.png" alt="" title="直播培训预告"></router-link>
          <div class="live_info" v-if="false">
            <div class="title">
              <h3>
                <img src="@/static/train/live.png" alt class="marR5 middle" />直播预告
              </h3>
            </div>
            <ul v-if="live.length > 0">
              <li v-for="(item, index) in live" :key="index">
                <h4>{{ item.title }}</h4>
                <p>
                  <i class="el-icon-s-custom"></i>
                  主讲人：{{ item.perName }}
                </p>
                <p>
                  <i class="el-icon-time"></i>
                  直播时间：{{ item.time }}
                </p>
              </li>
            </ul>
            <img src="@/static/train/Qr_code.png" alt="中国残联二维码" title="中国残联二维码" class="or_two" />
          </div>
        </li>
      </ul>
    </section>
    <section class="section_second">
      <div class="section_content flex">
        <div class="section_left">
          <h4 class="title marL15">
            政策要闻<small>河南残疾人就业政策，企业残疾人用人政策，残疾人新闻</small>
          </h4>
          <div class="news flex" v-if="home.laws.length > 0">
            <a :href="'/news/newDetail/?id='+(picImg.id?home.laws[0].id:home.laws[0].id)" target="_blank" :title="picImg.title" class="banner">
              <img :src="picImg.thumbnail || home.laws[0].thumbnail" alt="">
            </a>
            <ul class="list" v-if="home.laws">
              <li v-for="(item,index) in home.laws" :key="index" @click="goRouter('/news/newDetail/',item.id)" @mouseover="policyItem(item)">
                <div class="titles line_clamp1">{{ item.title }}</div>
                <div class="text line_clamp2">
                  {{ item.conAbstract }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="section_right">
          <ul class="tab flex">
            <li :class="{'active':newActive == 0}" @click="newActive = 0" class="cursorP">通知公告</li>
            <li :class="{'active':newActive == 1}" @click="newActive = 1" class="cursorP">本地政策</li>
          </ul>
          <ul class="list" v-if="newActive == 0">
            <li v-for="(item,index) in home.notices" :key="index" @click="goRouter('/news/newDetail/',item.id)">
              <div class="text line_clamp1">{{ item.title }}</div>
              <div class="time">
                {{ $currentYear(item.createTime) }}
              </div>
            </li>
          </ul>
          <ul class="list" v-else>
            <li v-for="(item,index) in home.localLaws" :key="index" @click="goRouter('/news/newDetail/',item.id)">
              <div class="text line_clamp1">{{ item.title }}</div>
              <div class="time">
                {{ $currentYear(item.createTime) }}
              </div>
            </li>
          </ul>
          <router-link :to="active == 0?'/news/msg_list':'/news/policy_list'" target="_blank" class="more"><i>-</i>查看更多内容<i>-</i>
          </router-link>
        </div>
      </div>
    </section>
    <section class="section_third">
      <div class="section_content">
        <ul class="tab marL15">
          <li v-for="(n,i) in jobTab" :class="{'active':jobActive == i}" :key="i" @click="jobSelect(i)">{{ n }}</li>
        </ul>
        <div v-if="jobActive == 0">
          <ul class="list flex-wrap" v-show="home.recomandJobs">
            <li class="box" v-for="(item,index) in home.recomandJobs" :key="index" @click="goRouter('/job/jobDetail?id=',item.id)">
              <div class="top">
                <div class="name flex"><span class="line_clamp1">{{ item.jobName }}</span> <span class="time">[{{ $currentYear(item.updateTime) }}]</span></div>
                <p class="line_clamp1">
                  <span v-if="item.cityid">{{ item.cityid }} <span v-if="item.threeCityid">-{{ item.threeCityid }}</span> <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.edu">{{ item.edu }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.exp">{{ item.exp }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.jobType">{{ item.jobType }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.distype.length > 1 || item.distype.length == 0">残疾类别不限</span>
                  <span v-else><span v-for="(n,i) in item.distype" :key="i">{{ n.disType + ' ' + n.disTypeLevel }}</span></span>
                </p>
                <div class="welfare">
                  <span v-for="(n,i) in item.jobLabels" :key="i">{{ n.labelName }}</span>
                </div>
                <div class="money" v-if="item.jobSalary">{{ item.jobSalary }}</div>
                <div class="money" v-else>面议</div>
              </div>
              <div class="bottom flex" v-if="item.companyInfo">
                <img :src="item.companyInfo.logo" class="logo err_logo">
                <div class="info">
                  <div class="name">
                    {{ item.companyInfo.companyName }}
                  </div>
                  <p>
                    <span v-if="item.hyTop">{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.pr }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.mun }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="jobActive == 1">
          <ul class="list flex-wrap" v-show="home.job1">
            <li class="box" v-for="(item,index) in home.job1" :key="index" @click="goRouter('/job/jobDetail?id=',item.id)">
              <div class="top">
                <div class="name flex"><span class="line_clamp1">{{ item.jobName }}</span> <span class="time">[{{ $currentYear(item.updateTime) }}]</span></div>
                <p class="line_clamp1">
                  <span v-if="item.cityid">{{ item.cityid }} <span v-if="item.threeCityid">-{{ item.threeCityid }}</span> <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.edu">{{ item.edu }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.exp">{{ item.exp }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.jobType">{{ item.jobType }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.distype.length > 1 || item.distype.length == 0">残疾类别不限</span>
                  <span v-else><span v-for="(n,i) in item.distype" :key="i">{{ n.disType + ' ' + n.disTypeLevel }}</span></span>
                </p>
                <div class="welfare">
                  <span v-for="(n,i) in item.jobLabels" :key="i">{{ n.labelName }}</span>
                </div>
                <div class="money">
                  {{ item.jobSalary }}
                </div>
              </div>
              <div class="bottom flex" v-if="item.companyInfo">
                <img :src="item.companyInfo.logo" class="logo err_logo">
                <div class="info">
                  <div class="name">
                    {{ item.companyInfo.companyName }}
                  </div>
                  <p>
                    <span v-if="item.hyTop">{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.pr }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.mun }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="jobActive == 2">
          <ul class="list flex-wrap" v-show="home.job2">
            <li class="box" v-for="(item,index) in home.job2" :key="index" @click="goRouter('/job/jobDetail?id=',item.id)">
              <div class="top">
                <div class="name flex"><span class="line_clamp1">{{ item.jobName }}</span> <span class="time">[{{ $currentYear(item.updateTime) }}]</span></div>
                <p class="line_clamp1">
                  <span v-if="item.cityid">{{ item.cityid }} <span v-if="item.threeCityid">-{{ item.threeCityid }}</span> <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.edu">{{ item.edu }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.exp">{{ item.exp }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.jobType">{{ item.jobType }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.distype.length > 1 || item.distype.length == 0">残疾类别不限</span>
                  <span v-else><span v-for="(n,i) in item.distype" :key="i">{{ n.disType + ' ' + n.disTypeLevel }}</span></span>
                </p>
                <div class="welfare">
                  <span v-for="(n,i) in item.jobLabels" :key="i">{{ n.labelName }}</span>
                </div>
                <div class="money">
                  {{ item.jobSalary }}
                </div>
              </div>
              <div class="bottom flex" v-if="item.companyInfo">
                <img :src="item.companyInfo.logo" class="logo err_logo">
                <div class="info">
                  <div class="name">
                    {{ item.companyInfo.companyName }}
                  </div>
                  <p>
                    <span v-if="item.hyTop">{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.pr }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.mun }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="jobActive == 3">
          <ul class="list flex-wrap" v-show="home.job3">
            <li class="box" v-for="(item,index) in home.job3" :key="index" @click="goRouter('/job/jobDetail?id=',item.id)">
              <div class="top">
                <div class="name flex"><span class="line_clamp1">{{ item.jobName }}</span> <span class="time">[{{ $currentYear(item.updateTime) }}]</span></div>
                <p class="line_clamp1">
                  <span v-if="item.cityid">{{ item.cityid }} <span v-if="item.threeCityid">-{{ item.threeCityid }}</span> <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.edu">{{ item.edu }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.exp">{{ item.exp }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.jobType">{{ item.jobType }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.distype.length > 1 || item.distype.length == 0">残疾类别不限</span>
                  <span v-else><span v-for="(n,i) in item.distype" :key="i">{{ n.disType + ' ' + n.disTypeLevel }}</span></span>
                </p>
                <div class="welfare">
                  <span v-for="(n,i) in item.jobLabels" :key="i">{{ n.labelName }}</span>
                </div>
                <div class="money">
                  {{ item.jobSalary }}
                </div>
              </div>
              <div class="bottom flex" v-if="item.companyInfo">
                <img :src="item.companyInfo.logo" class="logo err_logo">
                <div class="info">
                  <div class="name">
                    {{ item.companyInfo.companyName }}
                  </div>
                  <p>
                    <span v-if="item.hyTop">{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.pr }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.mun }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="jobActive == 4">
          <ul class="list flex-wrap" v-show="home.job4">
            <li class="box" v-for="(item,index) in home.job4" :key="index" @click="goRouter('/job/jobDetail?id=',item.id)">
              <div class="top">
                <div class="name flex"><span class="line_clamp1">{{ item.jobName }}</span> <span class="time">[{{ $currentYear(item.updateTime) }}]</span></div>
                <p class="line_clamp1">
                  <span v-if="item.cityid">{{ item.cityid }} <span v-if="item.threeCityid">-{{ item.threeCityid }}</span> <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.edu">{{ item.edu }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.exp">{{ item.exp }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.jobType">{{ item.jobType }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.distype.length > 1 || item.distype.length == 0">残疾类别不限</span>
                  <span v-else><span v-for="(n,i) in item.distype" :key="i">{{ n.disType + ' ' + n.disTypeLevel }}</span></span>
                </p>
                <div class="welfare">
                  <span v-for="(n,i) in item.jobLabels" :key="i">{{ n.labelName }}</span>
                </div>
                <div class="money">
                  {{ item.jobSalary }}
                </div>
              </div>
              <div class="bottom flex" v-if="item.companyInfo">
                <img :src="item.companyInfo.logo" class="logo err_logo">
                <div class="info">
                  <div class="name">
                    {{ item.companyInfo.companyName }}
                  </div>
                  <p>
                    <span v-if="item.hyTop">{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.pr }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.mun }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="jobActive == 5">
          <ul class="list flex-wrap" v-show="home.job5">
            <li class="box" v-for="(item,index) in home.job5" :key="index" @click="goRouter('/job/jobDetail?id=',item.id)">
              <div class="top">
                <div class="name flex"><span class="line_clamp1">{{ item.jobName }}</span> <span class="time">[{{ $currentYear(item.updateTime) }}]</span></div>
                <p class="line_clamp1">
                  <span v-if="item.cityid">{{ item.cityid }} <span v-if="item.threeCityid">-{{ item.threeCityid }}</span> <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.edu">{{ item.edu }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.exp">{{ item.exp }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.jobType">{{ item.jobType }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.distype.length > 1 || item.distype.length == 0">残疾类别不限</span>
                  <span v-else><span v-for="(n,i) in item.distype" :key="i">{{ n.disType + ' ' + n.disTypeLevel }}</span></span>
                </p>
                <div class="welfare">
                  <span v-for="(n,i) in item.jobLabels" :key="i">{{ n.labelName }}</span>
                </div>
                <div class="money">
                  {{ item.jobSalary }}
                </div>
              </div>
              <div class="bottom flex" v-if="item.companyInfo">
                <img :src="item.companyInfo.logo" class="logo err_logo">
                <div class="info">
                  <div class="name">
                    {{ item.companyInfo.companyName }}
                  </div>
                  <p>
                    <span v-if="item.hyTop">{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.pr }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.mun }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="jobActive == 6">
          <ul class="list flex-wrap" v-show="home.job6">
            <li class="box" v-for="(item,index) in home.job6" :key="index" @click="goRouter('/job/jobDetail?id=',item.id)">
              <div class="top">
                <div class="name flex"><span class="line_clamp1">{{ item.jobName }}</span> <span class="time">[{{ $currentYear(item.updateTime) }}]</span></div>
                <p class="line_clamp1">
                  <span v-if="item.cityid">{{ item.cityid }} <span v-if="item.threeCityid">-{{ item.threeCityid }}</span> <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.edu">{{ item.edu }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.exp">{{ item.exp }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.jobType">{{ item.jobType }} <el-divider direction="vertical"></el-divider></span>
                  <span v-if="item.distype.length > 1 || item.distype.length == 0">残疾类别不限</span>
                  <span v-else><span v-for="(n,i) in item.distype" :key="i">{{ n.disType + ' ' + n.disTypeLevel }}</span></span>
                </p>
                <div class="welfare">
                  <span v-for="(n,i) in item.jobLabels" :key="i">{{ n.labelName }}</span>
                </div>
                <div class="money">
                  {{ item.jobSalary }}
                </div>
              </div>
              <div class="bottom flex" v-if="item.companyInfo">
                <img :src="item.companyInfo.logo" class="logo err_logo">
                <div class="info">
                  <div class="name">
                    {{ item.companyInfo.companyName }}
                  </div>
                  <p>
                    <span v-if="item.hyTop">{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.pr }} <el-divider direction="vertical"></el-divider></span>
                    <span>{{ item.companyInfo.mun }}</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <router-link to="/job/" target="_blank" class="more">
          - 查看更多职位 -
        </router-link>
      </div>
    </section>
    <section class="section_fourth">
      <div class="section_content">
        <div class="section_left">
          <ul class="tab marL15">
            <li :class="{'active':trainActive == 0}" @click="trainActive = 0">推荐培训</li>
            <li :class="{'active':trainActive == 1}" @click="trainActive = 1">视频课程</li>
          </ul>
          <div class="section_list trainList" v-if="trainActive == 0">
            <template v-for="(item,index) in trainList">
              <trainItem :data="item" />
            </template>
            <!-- <ul class="list flex-wrap" v-if="home.trainList">
              <li v-for="(item,index) in home.trainList" :key="index" @click="goRouter('/training/trainDetail',item.id)">
                <div class="name line_clamp1">{{ item.trainName }}</div>
                <p class="line_clamp1">培训时间：{{ $currentYear(item.trainBeginTime) }} -
                  {{ $currentYear(item.trainEndTime) }}</p>
                <p class="line_clamp1" v-if="item.trainAddress">培训地点：{{ item.trainAddress }}</p>
                <div class="number line_clamp1">已报名 {{ item.applyNumber }} 人/共招生{{ item.maxNumber }}人</div>
                <div class="btn green" v-show="item.ing == 2">
                  报名中
                </div>
                <div class="btn red" v-show="item.ing == 3">
                  报名结束
                </div>
                <div class="btn info" v-show="item.ing == 4">
                  未开始
                </div>
              </li>
            </ul> -->
          </div>
          <div class="section_list publicList" v-else>
            <ul class="list flex-wrap">
              <li v-for="(item,index) in home.courseList" :key="index" @click="goRouter('/training/publicDetail',item.id)">
                <img :src="item.imgurl" class="banner">
                <div class="info">
                  <div class="name line_clamp2">{{ item.trainName }}</div>
                  <p>课程提供：{{ item.fwjgname || '河南省残疾人就业指导中心' }}</p>
                  <p>课程节数：{{ item.reamark }}</p>
                  <!--                <p>课程时长：{{item.hits}}</p>-->
                </div>
              </li>
            </ul>
          </div>
        </div>
        <router-link :to="trainActive == 0?'/train/':'/train?active=1'" target="_blank" class="more">
          - 查看更多{{ trainActive == 0 ? '培训' : '课程' }} -
        </router-link>
      </div>

    </section>
    <section class="section_fifth">
      <div class="section_content flex">
        <div class="section_left">
          <h2 class="title">
            盲按店展示
          </h2>
          <ul class="list">
            <li v-for="(item,index) in home.blindShops" :key="index" @click="$linkRouter('/contentDetail/detail?id='+item.id+'&name=盲按')">
              <img :src="item.logo" :title="item.name">
              <div class="info">
                <h3 class="line_clamp1">{{ item.name }}</h3>
                <p class="line_clamp2">
                  {{ item.addrProvince + item.addrCity + item.addrThreeCity + item.addrDetail }}</p>
              </div>
            </li>
          </ul>
          <router-link to="/blindShop" target="_blank" class="more">
            - 查看更多 -
          </router-link>
        </div>
        <div class="section_center">
          <h2 class="title">
            就业孵化基地展示
          </h2>
          <ul class="list">
            <li v-for="(item,index) in home.incubations" :key="index" @click="$linkRouter('/contentDetail/detail?id='+item.id+'&name=孵化')">
              <img :src="item.logo" :title="item.name">
              <div class="info">
                <h3 class="line_clamp1">{{ item.name }}</h3>
                <p class="line_clamp2">
                  {{ item.addrProvince + item.addrCity + item.addrThreeCity + item.addrDetail }}</p>
              </div>
            </li>
          </ul>
          <router-link to="/hatch" target="_blank" class="more">
            - 查看更多 -
          </router-link>
        </div>
        <div class="section_right">
          <h2 class="title">
            非遗文化展示
          </h2>
          <ul class="list">
            <li v-for="(item,index) in home.genetics" :key="index" @click="$linkRouter('/contentDetail/detail?id='+item.id+'&name=文化')">
              <img :src="item.logo" class="banner">
              <div class="info">
                <div class="name line_clamp1">
                  {{ item.name }}
                </div>
                <p>已浏览人数</p>
                <span>{{ item.hits || 0 }}人</span>
              </div>
            </li>
          </ul>
          <router-link to="/heritage" target="_blank" class="more">
            - 查看更多 -
          </router-link>
        </div>
      </div>
    </section>
    <section class="section_sixth">
      <div class="section_content">
        <div class="section_left">
          <ul class="tab marL15">
            <li :class="{'active':companyActive == 0}" @click="companyTab(0)">残疾人企业</li>
            <li :class="{'active':companyActive == 1}" @click="companyTab(1)">爱心企业</li>
            <li :class="{'active':companyActive == 2}" @click="companyTab(2)">知名企业</li>
          </ul>
          <ul class="list flex-wrap" v-if="companyActive == 0">
            <li v-for="(item,index) in home.company1" :key="index" @click="$linkRouter('/job/businessDetails?companyId='+item.id)">
              <img :src="item.logo" class="logo">
              <div class="name line_clamp1">
                {{ item.companyName }}
              </div>
              <p>
                <span>{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                <span>{{ item.pr }} </span>
              </p>
              <el-button><span>{{ item.jobs }}</span>个热招职位</el-button>
            </li>
          </ul>
          <ul class="list flex-wrap" v-if="companyActive == 1">
            <li v-for="(item,index) in home.company2" :key="index" @click="$linkRouter('/job/businessDetails?companyId='+item.id)">
              <img :src="item.logo" class="logo">
              <div class="name line_clamp1">
                {{ item.companyName }}
              </div>
              <p>
                <span>{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                <span>{{ item.pr }} </span>
              </p>
              <el-button><span>{{ item.jobs }}</span>个热招职位</el-button>
            </li>
          </ul>
          <ul class="list flex-wrap" v-if="companyActive == 2">
            <li v-for="(item,index) in home.company3" :key="index" @click="$linkRouter('/job/businessDetails?companyId='+item.id)">
              <img :src="item.logo" class="logo">
              <div class="name line_clamp1">
                {{ item.companyName }}
              </div>
              <p>
                <span>{{ item.hyTop }} <el-divider direction="vertical"></el-divider></span>
                <span>{{ item.pr }} </span>
              </p>
              <el-button><span>{{ item.jobs }}</span>个热招职位</el-button>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="section_seventh">
      <div class="section_content">
        <div class="title marL15">
          残疾人风采
          <router-link to="/news/people_list" target="_blank" class="more">更多 <i class="el-icon-d-arrow-right"></i>
          </router-link>
        </div>
        <ul class="list flex-wrap">
          <li v-for="(item,index) in home.cjrfc" :key="index" @click="goRouter('/news/newDetail',item.id)">
            <!--            <div class="info download" v-if="(index+1)%2 == 0" :class="(index+1)%2 == 0?'download':''">-->
            <!--              <img src="~/static/henan/public/downd.png" alt="" class="icon">-->
            <!--              <div class="name line_clamp2">-->
            <!--                {{item.title}}-->
            <!--              </div>-->
            <!--              <div class="text line_clamp2">-->
            <!--                {{item.conAbstract}}-->
            <!--              </div>-->
            <!--            </div>-->
            <img :src="item.thumbnail" class="banner">
            <div class="info up">
              <img src="~/static/henan/public/up.png" alt="" class="icon">
              <div class="name line_clamp2">
                {{ item.title }}
              </div>
              <div class="text line_clamp2">
                {{ item.conAbstract }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <login-prompt :goShow="isLogin" @close="handleClose" title="登录" :text="title"></login-prompt>
  </div>
</template>
<script>
import Login from '@/components/henan-cdpe/public/login';
import loginPrompt from '@/components/public/loginPrompt';
import { mapMutations } from 'vuex';
import trainItem from '@/components/public/trainItem';

export default {
  name: 'henan',
  components: { Login, loginPrompt, trainItem },
  data() {
    return {
      home: {
        hotJobs:[],
        laws:[]
      },
      picImg: [],
      select: '搜职位',
      search: '',
      active: 0,
      newActive: 0,
      jobActive: 0,
      trainActive: 0,
      jobTab: ['职位推荐', '视力残疾', '听力残疾', '言语残疾', '肢体残疾', '智力残疾', '精神残疾'],
      companyActive: 0,
      exhibitsActive: 0,
      loginType: [],
      isLogin: false,
      title: '',
      live: [],
      trainList: []
    };
  },
  methods: {
    ...mapMutations(['getAllCity']),
    info() {
      this.$axios.get('/api/app-jycy-henan/henan/getSiteData').then(res => {
        this.home = res.data;
        this.loginType = JSON.parse(localStorage.getItem('userInfo') || null);
        if (this.loginType) {
          if (this.loginType.userType == 2) {
            this.$router.push({ path: '/enterprise' });
          }
        }
      });
    },
    //直播预告
    notice() {
      this.$api.zhiboActivityListApi({provinceid:'p20'}).then(res => {
        if (res.data.success) {
          this.live = res.data.data;
        }
      });
    },
    //  swiper轮播
    swiperTab(i) {
      this.active = i;
    },
    //轮播关联
    swiperItem(i) {
      this.$refs.swiper.setActiveItem(i);
    },
    //  职位残疾类别筛选
    jobSelect(i) {
      this.jobActive = i;
    },
    //  公司残疾类别筛选
    companyTab(i) {
      this.companyActive = i;
    },
    //政策要闻伪轮播
    policyItem(item) {
      this.picImg = item;
    },
    goRouter(url, id) {
      const { href } = this.$router.resolve({
        path: url,
        query: {
          id: id
        }
      });
      window.open(href, '_blank');
    },
    handleClose() {
      this.isLogin = false;
    },
    goRouters(url, id, haslogin) {

      if (this.loginType) {
        const { href } = this.$router.resolve({
          path: url,
          query: {
            id: id
          }
        });
        window.open(href, '_blank');
      } else {
        console.log(222222)
        this.isLogin = true;
        this.title = '登录之后才可以进行下一步操作！';
      }
    },
    train(val) {
      this.loading = true;
      try {
        this.$api
          .queryCourseList({
            adressCityId: '',
            adressProvinceId: '',
            adressThreeCityId: '',
            disableLevel: '',
            disableType: '',
            heatOrder: '',
            assessOrder: '',
            registrationStatus: '',
            trainIng: '',
            trainType: val,
            pageNum: 1,
            pageSize: 6
          })
          .then(res => {
            res = res.data;
            if (res.success) {
              this.trainList = res.data?.courseListOutDTOIPage?.records ?? [];

              this.loading = false;
            }
          });
      } catch (e) {
        this.loading = false;
      }
    }
  },
  created() {
    this.getAllCity('河南省');
    this.$getChildCity('河南省', '河南省');
    this.info();
    this.notice();
    this.train();
  }
};
</script>

<style scoped lang="less">
@import '../assets/henan/index.less';
</style>
